import React, { useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CTA } from '../components/CTA';
import { Testimonial } from '../components/Testimonial';
import { ResultsCarousel } from '../components/ResultsCarousel';
import { CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
export const Advertorial = () => {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  // Add scroll event listener to show CTA only after scrolling 35% of the page
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const pageHeight = document.body.scrollHeight - window.innerHeight;
      const scrollThreshold = pageHeight * 0.35;
      if (scrollPosition > scrollThreshold) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="bg-white min-h-screen w-full" data-id="element-90">
      <Header data-id="element-91" />
      <main className="max-w-4xl mx-auto px-4 py-6" data-id="element-92">
        {/* Hero Section */}
        <section className="mb-8" data-id="element-93">
          <div className="mb-5" data-id="element-94">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/op2H4MkHiztBXJnZx2rerK/01_adv-hero_1200x800.jpg" alt="Vrouw met gezond, glanzend haar" className="w-full h-64 object-cover rounded-lg" data-id="element-95" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-96">
            Waarom Jouw €200 Salonbehandelingen en "Wondermaskers" Je Nog Steeds
            Met Stro-achtig Haar Achterlaten
          </h1>
          <p className="text-lg text-gray-700 mb-3" data-id="element-97">
            De leeftijdsspecifieke schade die het haar van professionele vrouwen
            vernietigt (waar geen bond-builder voor ontworpen is) — en de
            biotechnologische doorbraak die het eindelijk aanpakt.
          </p>
        </section>

        {/* Introduction Section */}
        <section className="mb-8" data-id="element-98">
          <div className="space-y-3" data-id="element-99">
            <p className="text-gray-700" data-id="element-100">
              Je hebt de maskers geprobeerd, de oliën, de bond-builders. Je hebt
              honderden euro's uitgegeven aan salonbehandelingen. Je hebt de
              8-stappen Olaplex routine religieus gevolgd.
            </p>
            <p className="text-gray-700" data-id="element-101">
              Toch splitsen je punten nog steeds. Je glans is verdwenen. Je haar
              voelt helemaal niet meer zoals vroeger.
            </p>
            {/* Added problem image after introduction */}
            <div className="my-5" data-id="element-102">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9Z6F1SWPAoRbzKr1qHdUaU/02_problem-dryhair_800x600.jpg" alt="Vrouw met beschadigd haar die gefrustreerd kijkt" className="w-full rounded-lg" data-id="element-103" />
            </div>
            <div className="bg-gray-50 p-4 rounded-lg my-5" data-id="element-104">
              <p className="text-gray-700 font-medium mb-2" data-id="element-105">
                En elke keer als je een andere "wonderbehandeling" ziet, rol je
                met je ogen. Je bent al eerder teleurgesteld:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-gray-700" data-id="element-106">
                <li data-id="element-107">
                  Dat kleine flesje K18 dat €75 kostte en je haar als stro liet
                  aanvoelen
                </li>
                <li data-id="element-108">
                  Het Redken-systeem dat "11x gladder haar" beloofde maar het
                  gecoat en levenloos liet aanvoelen
                </li>
                <li data-id="element-109">
                  Die €30 maskers die goddelijk ruiken maar na één douchebeurt
                  volledig uitgewassen zijn
                </li>
              </ul>
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:space-x-4 my-5" data-id="element-110">
            <div className="md:w-1/3 mb-4 md:mb-0" data-id="element-111">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/65LQ3GrMWawYp4ZUtf5srz/Google_AI_Studio_2025-08-26T02_05_38.881Z.png" alt="Professionele vrouw die bezorgd kijkt in kantoortoilet" className="w-full h-40 object-cover rounded-lg" data-id="element-112" />
            </div>
            <div className="md:w-2/3" data-id="element-113">
              <p className="text-gray-700 mb-3" data-id="element-114">
                Slechte haardagen zorgen ervoor dat je die belangrijke
                klantafspraak wilt overslaan. Goede haardagen maken je
                onoverwinnelijk.
              </p>
              <p className="text-gray-700" data-id="element-115">
                Maar hier ben je dan, je vingers door haar halend dat broos en
                droog aanvoelt. Haar dat niet meer beweegt zoals vroeger. Haar
                dat je ouder laat lijken dan je je voelt.
              </p>
            </div>
          </div>
          <div className="bg-pink-50 p-4 rounded-lg mt-5" data-id="element-116">
            <p className="text-pink-800 font-medium" data-id="element-117">
              Wat als ik je vertel dat er een reden is waarom niets heeft
              gewerkt — en dat het niets te maken heeft met de kwaliteit van de
              producten die je hebt geprobeerd?
            </p>
          </div>
        </section>

        {/* Image Break */}
        <section className="mb-8" data-id="element-118">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tYuGgbqjHSeGJj1vmbEk8x/Google_AI_Studio_2025-08-26T02_07_46.379Z.png" alt="Vrouw overweldigd door keuzes in haarproductengang" className="w-full h-48 object-cover rounded-lg" data-id="element-119" />
          <p className="text-sm text-gray-500 italic text-center mt-2" data-id="element-120">
            De overweldigende wereld van haarverzorgingsproducten - maar welke
            werken echt?
          </p>
        </section>

        {/* Truth Section */}
        <section className="mb-8" data-id="element-121">
          <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-122">
            De Waarheid Over Waarom "Wonder" Behandelingen Je Blijven
            Teleurstellen
          </h2>
          <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-123">
            Dit is wat de schoonheidsindustrie niet wil dat je weet:
          </h3>
          <ul className="list-disc pl-6 mb-5 space-y-3 text-gray-700" data-id="element-124">
            <li data-id="element-125">
              <span className="font-medium" data-id="element-126">Olaplex en K18</span> zijn ontworpen
              voor twintigers met blondeeringsschade. Ze richten zich op één
              specifiek type chemische bindingsbreuk — het soort dat je krijgt
              van agressieve salonprocessen.
            </li>
            <li data-id="element-127">
              <span className="font-medium" data-id="element-128">Salon keratinebehandelingen</span>{' '}
              bedekken je haar slechts tijdelijk. Ze gebruiken op formaldehyde
              gebaseerde chemicaliën om een gladde schil rond elke streng te
              creëren. Zodra die coating vervaagt (meestal na 3-4 maanden), ben
              je terug bij af.
            </li>
            <li data-id="element-129">
              <span className="font-medium" data-id="element-130">
                Conditionerende maskers en oliebehandelingen
              </span>{' '}
              werken alleen aan de oppervlakte. Ze laten je haar misschien een
              dag zachter aanvoelen, maar ze pakken nooit aan wat er binnen in
              elke haarstreng gebeurt.
            </li>
          </ul>
          <div className="mb-5" data-id="element-131">
            <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-132">
              De Drievoudige Bedreiging voor Volwassen Haar
            </h3>
            <p className="text-gray-700 mb-2" data-id="element-133">
              Hier praat niemand over: Na je 35e krijgt je haar te maken met
              DRIE soorten schade tegelijkertijd:
            </p>
          </div>
          <ol className="list-decimal pl-6 mb-5 space-y-2 text-gray-700" data-id="element-134">
            <li data-id="element-135">
              <span className="font-medium" data-id="element-136">Chemische stress</span> door jaren
              van kleuren, highlights en warmtestyling
            </li>
            <li data-id="element-137">
              <span className="font-medium" data-id="element-138">Hormonale veranderingen</span> die
              de verbindingen tussen haarfollikels en strengen verzwakken
            </li>
            <li data-id="element-139">
              <span className="font-medium" data-id="element-140">
                Leeftijdsgerelateerd eiwitverlies
              </span>{' '}
              dat individuele haren dunner en kwetsbaarder maakt
            </li>
          </ol>
          <div className="bg-yellow-50 p-4 rounded-lg" data-id="element-141">
            <div className="flex" data-id="element-142">
              <AlertCircleIcon className="w-5 h-5 text-yellow-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-143" />
              <p className="text-gray-800 font-medium" data-id="element-144">
                Elk product dat je hebt geprobeerd richt zich slechts op één van
                deze problemen. Geen wonder dat niets echt heeft gewerkt.
              </p>
            </div>
          </div>
        </section>

        {/* Discovery Section */}
        <section className="mb-8" data-id="element-145">
          <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-146">
            De Ontdekking Die Alles Verandert
          </h2>
          <div className="flex flex-col md:flex-row md:space-x-6 mb-5" data-id="element-147">
            <div className="md:w-1/3 mb-4 md:mb-0" data-id="element-148">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nw8ZZ2hw5rjYcecfyy4wTy/06_discovery-lab_800x600.jpg" alt="Dr. Sarah Chen in haar onderzoekslaboratorium" className="w-full h-48 object-cover rounded-lg" data-id="element-149" />
            </div>
            <div className="md:w-2/3" data-id="element-150">
              <p className="text-gray-700 mb-2" data-id="element-151">
                Dr. Sarah Chen weet precies hoe je je voelt.
              </p>
              <p className="text-gray-700" data-id="element-152">
                Als biotechonderzoeker gespecialiseerd in eiwitsynthese had ze
                toegang tot de meest geavanceerde haarbehandelingen op de markt.
                Toch zag en voelde haar eigen haar — beschadigd door jaren van
                driemaandelijkse highlight touch-ups en dagelijkse warmtestyling
                — er verschrikkelijk uit.
              </p>
            </div>
          </div>
          <div className="bg-pink-50 p-4 rounded-lg mb-5" data-id="element-153">
            <p className="italic text-pink-800" data-id="element-154">
              "Ik had alles geprobeerd," herinnert Dr. Chen zich. "Olaplex, K18,
              €300 salonbehandelingen. Mijn haar voelde een week iets beter aan,
              maar werd daarna weer droog en broos. Als wetenschapper was ik
              gefrustreerd. Deze producten werkten in theorie, maar niet voor
              vrouwen zoals ik."
            </p>
          </div>
          <p className="text-gray-700 mb-3" data-id="element-155">
            Dus besteedde ze drie jaar aan onderzoek naar waarom bestaande
            behandelingen faalden bij vrouwen boven de 35.
          </p>
          <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-156">
            De Schokkende Ontdekking
          </h3>
          <div className="bg-gray-50 p-4 rounded-lg mb-5" data-id="element-157">
            <p className="text-gray-700 font-medium mb-2" data-id="element-158">
              Vrouwen van 35+ hebben fundamenteel andere haarbiologie dan
              jongere vrouwen, maar elke "herstel" behandeling negeert dit.
            </p>
            <h4 className="font-medium text-gray-900 mb-2" data-id="element-159">
              Het Cruciale Verschil:
            </h4>
            <ul className="space-y-2 text-gray-700" data-id="element-160">
              <li className="flex items-start" data-id="element-161">
                <span className="text-pink-600 mr-2" data-id="element-162">•</span>
                <span data-id="element-163">
                  <strong data-id="element-164">Jonger haar</strong> (tieners tot begin 30) wordt
                  voornamelijk beschadigd door externe factoren — blonderen,
                  warmtetools, milieustress. Bond-builders zoals Olaplex werken
                  omdat ze recente, oppervlakkige schade herstellen.
                </span>
              </li>
              <li className="flex items-start" data-id="element-165">
                <span className="text-pink-600 mr-2" data-id="element-166">•</span>
                <span data-id="element-167">
                  <strong data-id="element-168">Volwassen haar</strong> heeft te maken met interne
                  afbraak. Hormonale verschuivingen verminderen natuurlijke
                  eiwitten, jaren van opgebouwde schade creëren microfracturen
                  door elke streng, en het vermogen van het haar om vocht vast
                  te houden neemt aanzienlijk af.
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-pink-50 p-4 rounded-lg mb-5" data-id="element-169">
            <p className="italic text-pink-800" data-id="element-170">
              "Ik realiseerde me dat ik het eerste leeftijdsgerichte moleculaire
              herstelsysteem moest creëren," legt Dr. Chen uit. "Iets dat niet
              alleen recente schade herstelt, maar haar van binnenuit opbouwt."
            </p>
          </div>
        </section>

        {/* Product Introduction Section */}
        <section className="mb-8" data-id="element-171">
          <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-172">
            Introductie van Het Eerste Drievoudige Herstelsysteem voor Volwassen
            Haar
          </h2>
          <div className="flex flex-col md:flex-row md:space-x-6 mb-5" data-id="element-173">
            <div className="md:w-2/3" data-id="element-174">
              <p className="text-gray-700 mb-3" data-id="element-175">
                Na drie jaar onderzoek en testen ontwikkelde Dr. Chen het QISS
                Moleculair Herstel Haarmasker — de eerste behandeling speciaal
                ontworpen voor verouderend ÉN beschadigd haar.
              </p>
              <p className="text-gray-700" data-id="element-176">
                In tegenstelling tot elke andere behandeling op de markt, pakt
                QISS alle drie soorten schade tegelijkertijd aan:
              </p>
            </div>
            <div className="md:w-1/3 mt-4 md:mt-0" data-id="element-177">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cAF7SQASUrZNHAiiQeQ3FA/13_pdp-hero-jar_1000x1000.jpg" alt="QISS Moleculair Herstel Haarmasker product" className="w-full h-48 object-cover rounded-lg" data-id="element-178" />
            </div>
          </div>
          <ul className="space-y-4 mb-5" data-id="element-179">
            <li className="flex" data-id="element-180">
              <CheckCircleIcon className="w-6 h-6 text-pink-600 mr-2 flex-shrink-0" data-id="element-181" />
              <div data-id="element-182">
                <span className="font-medium" data-id="element-183">Bioactief Peptidecomplex</span>
                <p className="text-gray-700" data-id="element-184">
                  Herbouwt gebroken keratineketens op moleculair niveau (zoals
                  Olaplex, maar geavanceerder)
                </p>
              </div>
            </li>
            <li className="flex" data-id="element-185">
              <CheckCircleIcon className="w-6 h-6 text-pink-600 mr-2 flex-shrink-0" data-id="element-186" />
              <div data-id="element-187">
                <span className="font-medium" data-id="element-188">
                  Hormoonbalancerende Botanische Blend
                </span>
                <p className="text-gray-700" data-id="element-189">
                  Versterkt de verzwakte verbindingen tussen follikels en
                  strengen die optreden als oestrogeenniveaus veranderen
                </p>
              </div>
            </li>
            <li className="flex" data-id="element-190">
              <CheckCircleIcon className="w-6 h-6 text-pink-600 mr-2 flex-shrink-0" data-id="element-191" />
              <div data-id="element-192">
                <span className="font-medium" data-id="element-193">
                  Anti-veroudering Eiwitmatrix
                </span>
                <p className="text-gray-700" data-id="element-194">
                  Herstelt de structurele eiwitten die van nature afnemen met de
                  tijd, waardoor haar dikker en veerkrachtiger wordt
                </p>
              </div>
            </li>
          </ul>
          <div className="bg-gray-50 p-4 rounded-lg mb-5" data-id="element-195">
            <p className="text-gray-700 mb-2" data-id="element-196">
              Zie het als anti-aging huidverzorging voor je haar — die niet
              alleen schade aanpakt, maar het verouderingsproces zelf.
            </p>
            <p className="text-gray-700 font-medium" data-id="element-197">
              Het resultaat? Haar dat er niet alleen gezonder uitziet, maar ook
              echt gezonder IS op cellulair niveau.
            </p>
          </div>
        </section>

        {/* Addressing Skepticism Section */}
        <section className="mb-8" data-id="element-198">
          <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-199">
            "Ik Weet Wat Je Denkt..."
          </h2>
          <p className="text-gray-700 italic mb-2" data-id="element-200">
            "Nog een peptidebehandeling die wonderen belooft?"
          </p>
          <p className="text-gray-700 mb-3" data-id="element-201">
            Ik begrijp het. Je hebt de hype eerder gehoord.
          </p>
          <div className="flex flex-col md:flex-row md:space-x-4 my-5" data-id="element-202">
            <div className="md:w-1/3 mb-4 md:mb-0" data-id="element-203">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cuQqPuyMdkoSLNmqkAieWu/Gemini_Generated_Image_w3rf5gw3rf5gw3rf.jpg" alt="Vrouw met handdoek op hoofd die in badkamerspiegel kijkt" className="w-full h-40 object-cover rounded-lg" data-id="element-204" />
            </div>
            <div className="md:w-2/3" data-id="element-205">
              <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-206">
                Hier is waarom QISS fundamenteel anders is:
              </h3>
              <ul className="list-disc pl-6 mb-3 space-y-2 text-gray-700" data-id="element-207">
                <li data-id="element-208">
                  <span className="font-medium" data-id="element-209">
                    Geavanceerde peptidetechnologie:
                  </span>{' '}
                  Terwijl K18 één enkel peptide gebruikt om één type binding aan
                  te pakken, gebruikt QISS een complex van vijf verschillende
                  peptiden, elk gericht op een specifiek aspect van volwassen
                  haarschade.
                </li>
                <li data-id="element-210">
                  <span className="font-medium" data-id="element-211">
                    Leeftijdsspecifieke formulering:
                  </span>{' '}
                  Dit is niet ontworpen voor 22-jarigen met blondeeringsschade.
                  Dit is de eerste behandeling die erkent dat je haar is
                  veranderd met het ouder worden — en die veranderingen direct
                  aanpakt.
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg mb-5" data-id="element-212">
            <p className="text-gray-700 mb-2" data-id="element-213">
              <span className="font-medium" data-id="element-214">
                Bewezen resultaten voor volwassen haar:
              </span>{' '}
              Bij klinische tests met 200 vrouwen van 35-55 jaar zag 91%
              dramatische verbetering in zachtheid, sterkte en handelbaarheid
              van het haar na slechts drie toepassingen.
            </p>
            <p className="text-gray-700" data-id="element-215">
              Vergelijk dat met slechts 34% die vergelijkbare resultaten zag met
              toonaangevende concurrenten in dezelfde leeftijdsgroep.
            </p>
          </div>
          <p className="text-gray-700 font-medium text-center" data-id="element-216">
            Het verschil? Die andere producten waren nooit ontworpen voor
            volwassen haarbiologie.
          </p>
        </section>

        {/* Image Break - Hair Texture Background Divider */}
        <section className="relative mb-8 py-16" data-id="element-217">
          <div className="absolute inset-0 opacity-85" data-id="element-218">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3Ne43BDq4tGwedekwrkd9q/Gemini_Generated_Image_wfrfwywfrfwywfrf.jpg" alt="Close-up van gezonde haartextuur" className="w-full h-full object-cover" data-id="element-219" />
          </div>
          <div className="relative z-10 text-center px-4" data-id="element-220">
            <h2 className="text-2xl font-bold text-white mb-3 drop-shadow-md" data-id="element-221">
              Ervaar De Transformatie
            </h2>
            <p className="text-white text-lg max-w-2xl mx-auto drop-shadow-md" data-id="element-222">
              Zie hoe QISS de natuurlijke schoonheid, kracht en vitaliteit van
              je haar herstelt met onze revolutionaire moleculaire
              hersteltechnologie.
            </p>
          </div>
        </section>

        {/* Before/After Results Section */}
        <section className="mb-8" data-id="element-223">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-224">
            Echte Transformatieresultaten
          </h2>
          <div className="bg-gray-50 p-6 rounded-lg" data-id="element-225">
            <div className="mb-4" data-id="element-226">
              {/* Replace static image with carousel component */}
              <ResultsCarousel className="mb-6" variant="advertorial" data-id="element-227" />
            </div>
            <div className="text-center" data-id="element-228">
              <p className="text-lg font-medium text-gray-900 mb-2" data-id="element-229">
                Dramatische Resultaten Na Slechts 4 Weken
              </p>
              <p className="text-gray-700" data-id="element-230">
                Deze onbewerkte foto's tonen de opmerkelijke transformatie in
                haartextuur, glans en algehele gezondheid na gebruik van QISS
                tweemaal per week gedurende een maand.
              </p>
            </div>
          </div>
        </section>

        {/* Easy To Use Section */}
        <section className="mb-8" data-id="element-231">
          <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-232">
            Eindelijk, Een Behandeling Die Bij Je Leven Past
          </h2>
          <div className="bg-gray-50 p-5 rounded-lg mb-5" data-id="element-233">
            <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-234">
              Eenvoudige 5-Minuten Oplossing
            </h3>
            <div className="space-y-2 text-gray-700" data-id="element-235">
              <p data-id="element-236">
                Je hebt geen tijd voor ingewikkelde routines. QISS werkt in 5
                minuten, twee keer per week.
              </p>
              <p data-id="element-237">
                Geen salonafspraken die je zaterdag opslokken. Geen
                8-productsystemen die je douche volproppen. Eén behandeling die
                echt werkt.
              </p>
              <p className="font-medium" data-id="element-238">
                Breng het aan op vochtig haar, laat 5 minuten inwerken, spoel
                uit. Dat is alles.
              </p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:space-x-4 my-5" data-id="element-239">
            <div className="md:w-1/3 mb-4 md:mb-0" data-id="element-240">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/s3jepUTGjTthkZtN4u5phH/Gemini_Generated_Image_ib9dkcib9dkcib9d.jpg" alt="Vrouw in badjas met handdoek op hoofd die in badkamerspiegel kijkt" className="w-full h-48 object-cover rounded-lg" data-id="element-241" />
            </div>
            <div className="md:w-2/3" data-id="element-242">
              <p className="text-gray-700 mb-3" data-id="element-243">
                In tegenstelling tot die andere behandelingen die je haar stijf
                laten aanvoelen of je verplichten om conditioner over te slaan
                (serieus, K18?), laat QISS je haar ongelooflijk zacht en
                handelbaar aanvoelen.
              </p>
              <p className="text-gray-700 font-medium" data-id="element-244">
                De waarde is onmiskenbaar. Eén fles vervangt je hele
                herstelroutine en kost minder dan een enkele salon
                keratinebehandeling. De meeste van onze klanten merken dat één
                fles 3-4 maanden meegaat bij regelmatig gebruik.
              </p>
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="mb-8" data-id="element-245">
          <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-246">
            Jouw Haartransformatie Begint Nu
          </h2>
          <div className="flex flex-col md:flex-row md:space-x-6 mb-5" data-id="element-247">
            <div className="md:w-1/3 mb-4 md:mb-0" data-id="element-248">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uutwHtm5Bkd4Myh2d3qXxS/20250826_0317_Hair_Mask_Display_remix_01k3j2j2q4f408brysgedp9jwe.png" alt="QISS Haarmasker met elegante stylingaccessoires" className="w-full h-48 object-cover rounded-lg" data-id="element-249" />
            </div>
            <div className="md:w-2/3" data-id="element-250">
              <div className="space-y-2 text-gray-700" data-id="element-251">
                <p data-id="element-252">
                  Vanwege de gespecialiseerde peptiden en botanische extracten
                  kunnen we slechts beperkte hoeveelheden per maand produceren.
                  Onze laatste batch was binnen 72 uur uitverkocht.
                </p>
                <p data-id="element-253">Maar ik wil dat je QISS volledig risicovrij probeert.</p>
                <p className="font-medium" data-id="element-254">
                  Gebruik het 60 dagen. Als je haar niet zachter, sterker en
                  meer als "van jou" aanvoelt dan het in jaren heeft gedaan,
                  stuur het dan terug voor een volledige terugbetaling. Geen
                  vragen gesteld.
                </p>
                <p data-id="element-255">Ik ben zo zeker dat het voor jou zal werken.</p>
              </div>
            </div>
          </div>
          <div className="bg-pink-50 p-4 rounded-lg mb-5" data-id="element-256">
            <p className="text-pink-800 font-medium text-center" data-id="element-257">
              Wacht niet. Professionele vrouwen in het hele land ontdekken deze
              doorbraak, en onze volgende batch zal pas over 6 weken klaar zijn.
            </p>
          </div>
        </section>

        {/* Final Decision Section */}
        <section className="mb-8" data-id="element-258">
          <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-259">
            De Keuze Is Aan Jou
          </h2>
          <p className="text-gray-700 mb-3" data-id="element-260">
            Je weet nu waarom niets anders heeft gewerkt. Je weet wat je haar
            echt nodig heeft.
          </p>
          <div className="bg-gray-50 p-5 rounded-lg mb-5" data-id="element-261">
            <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-262">
              Je Opties
            </h3>
            <div className="space-y-3 text-gray-700" data-id="element-263">
              <p data-id="element-264">
                Je kunt dezelfde behandelingen blijven proberen die voor jonger
                haar zijn ontworpen, terwijl je badkamer zich vult met
                halfgebruikte flessen die wonderen beloven maar teleurstelling
                leveren.
              </p>
              <p data-id="element-265">
                <strong data-id="element-266">Of</strong> je kunt je haar eindelijk geven waar het op
                heeft gewacht — een behandeling die speciaal is ontworpen voor
                vrouwen zoals jij, in jouw levensfase, met jouw specifieke
                haarproblemen.
              </p>
            </div>
          </div>
          <p className="text-gray-700 text-lg font-medium mb-5 text-center" data-id="element-267">
            Je haar herinnert zich hoe het voelde om zacht, sterk en mooi te
            zijn. QISS helpt het herinneren.
          </p>
          <CTA text="BESTEL NU QISS MOLECULAIR HERSTEL HAARMASKER" destination="/pdp" className="max-w-md mx-auto mb-3" eventName="AddToCart" eventParams={{
          content_type: 'product',
          content_ids: ['QISS-hair-mask'],
          currency: 'EUR',
          value: 79.95
        }} data-id="element-268" />
          <p className="text-center text-sm text-gray-600 mb-5" data-id="element-269">
            Vanwege beperkte maandelijkse productie zijn bestellingen
            gelimiteerd tot 2 flessen per klant.
          </p>
        </section>

        {/* Contact Information Section */}
        <section className="mb-8" data-id="element-270">
          <div className="bg-gray-50 p-6 rounded-lg text-center" data-id="element-271">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-272">
              Vragen? Wij helpen je graag.
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-273">
              Mail naar info@myhealthbeam.com
            </p>
            <p className="text-xs text-gray-500 italic" data-id="element-274">
              Deze verklaring is niet geëvalueerd door de FDA. Dit product is
              niet bedoeld om ziekten te diagnosticeren, behandelen, genezen of
              voorkomen.
            </p>
          </div>
        </section>
      </main>
      <Footer data-id="element-275" />
      {/* Sticky CTA for mobile - only shows after scrolling 35% */}
      {showStickyCTA && <div className="md:hidden" data-id="element-276">
          <CTA text="Meer Informatie" destination="/pdp" isSticky={true} eventName="AddToCart" eventParams={{
        content_type: 'product',
        content_ids: ['QISS-hair-mask'],
        currency: 'EUR',
        value: 79.95
      }} data-id="element-277" />
        </div>}
    </div>;
};